// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3qu88","header":"ReportDetails_header__2TSNk","title":"ReportDetails_title__3pTD-","left":"ReportDetails_left__3LYVh"};